import React, { useEffect, useState } from "react";
import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import {
  BrowserRouter,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Proje from "./pages/projeler/ProjeList";
import Junior from "./pages/junior-senior/junior";
import Senior from "./pages/junior-senior/Senior";
import Sorular from "./pages/sss/Sorular";
import Kayit from "./pages/Kayit-giris/Kayit";
import Kayit2 from "./pages/Kayit-giris/Kayit2";
import Giris from "./pages/Kayit-giris/Giris";
import Kayit3 from "./pages/Kayit-giris/Kayit3";
import JuniorDetay from "./pages/junior-senior/JuniorDetay";
import SeniorDetay from "./pages/junior-senior/SeniorDetay";
import Hesabim from "./pages/Hesabim/Hesabim";
import ScrollToTop from "./components/ScrollToTop";
import ProjectEditPage from "./pages/projeler/ProjectEditPage";
import SifremiUnuttum from "./pages/Kayit-giris/SifremiUnuttum";
import YeniSifre from "./pages/Kayit-giris/YeniSifre";
import Bildirimler from "./pages/Bildirimler/Bildirimler";
import Anket from "./pages/Anket/Anket";
import { useDispatch, useSelector } from "react-redux";
import "./utils/interceptors";
import { refreshAccessToken } from "./redux/actions";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotFoundPage from "./pages/Hatalar/NotFoundPage";
import ServerErrorPage from "./pages/Hatalar/ServerErrorPage";
import eventEmitter from "./utils/eventEmitter";
import ErrorBoundary from "./components/ErrorBoundary";
import ProtectedRoute from "./components/ProtectedRoute";
import { HelmetProvider, Helmet } from "react-helmet-async";
import AcikRiza from "./pages/sozlesmeler/AcikRiza";
import UyelikKullanici from "./pages/sozlesmeler/UyelikKullanici";
import KvkkY from "./pages/sozlesmeler/KvkkY";
import GizlilikCerez from "./pages/sozlesmeler/GizlilikCerez";
import CerezPopup from "./pages/Kayit-giris/CerezPopup";

const App = () => {
  const [ratingState, setRatingState] = useState({
    isOpen: false,
    voteId: null,
  });
  const dispatch = useDispatch();

  const { isAuthenticated } = useSelector((state) => state.auth);

  // Auth yönetimi
  useEffect(() => {
    const location = window.location.pathname;
    if (location === "/giris_yap" || location === "/kayit_ol") {
      return;
    }

    const initializeAuth = async () => {
      try {
        const result = await dispatch(refreshAccessToken()).unwrap();
        if (!result || !result.accessToken) {
          return;
        }
      } catch (error) {
        // console.error("Token yenileme hatası:", error);
      }
    };

    initializeAuth();

    const refreshInterval = setInterval(async () => {
      try {
        const result = await dispatch(refreshAccessToken()).unwrap();
        if (!result || !result.accessToken) {
          return;
        }
      } catch (error) {
        // console.error("Token yenileme hatası (interval):", error);
      }
    }, 14 * 60 * 1000);

    return () => {
      clearInterval(refreshInterval);
    };
  }, [dispatch]);

  return (
    <HelmetProvider>
      <Helmet>
        {import.meta.env.MODE === "development" ? (
          <meta name="robots" content="noindex, nofollow" />
        ) : (
          <meta name="robots" content="index, follow" />
        )}
      </Helmet>
      <BrowserRouter>
        <ErrorBoundary>
          <Header
            isAuthenticated={isAuthenticated}
            setRatingIsOpen={setRatingState}
          />
          <ScrollToTop />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Helmet>
                    <title>
                      Juniors Center - Gerçek Projeler, Gerçek Deneyim
                    </title>
                    <meta
                      name="description"
                      content="Genç yetenekleri projelerle buluşturan dijital platform. Hemen katıl, deneyim kazan, geleceğe hazır ol."
                    />
                    <meta
                      property="og:title"
                      content="Juniors Center – Gerçek Projeler, Gerçek Deneyim"
                    />
                    <meta
                      property="og:description"
                      content="Genç yetenekleri projelerle buluşturan dijital platform. Hemen katıl, deneyim kazan, geleceğe hazır ol."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <Home />
                </>
              }
            />
            <Route
              path="/projeler"
              element={
                <>
                  <Helmet>
                    <title>Projeler - Aktif Projeler ve Fırsatlar</title>
                    <meta
                      name="description"
                      content="Juniors platformunda aktif projeleri keşfedin. Web ve mobil projelerde yer alın, deneyim kazanın ve portföyünüzü geliştirin."
                    />
                    <meta property="og:title" content="Projeler | Juniors" />
                    <meta
                      property="og:description"
                      content="Juniors platformunda aktif projeleri keşfedin. Web ve mobil projelerde yer alın, deneyim kazanın ve portföyünüzü geliştirin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <Proje />
                </>
              }
            />
            <Route
              path="/projeler/edit/:projectId"
              element={
                <ProtectedRoute>
                  <ProjectEditPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/juniorlar"
              element={
                <>
                  <Helmet>
                    <title>
                      Juniorlar - Projelere Katılabilecek Yetenekler
                    </title>
                    <meta
                      name="description"
                      content="Platformdaki tüm Junior'ları keşfedin. Projelere katılmış genç yetenekleri inceleyin ve profillerine göz atın."
                    />
                    <meta
                      property="og:title"
                      content="Juniorlar – Projelere Katılabilecek Genç Yetenekler"
                    />
                    <meta
                      property="og:description"
                      content="Platformdaki tüm Junior'ları burada görebilirsin. Projelere katılmış genç yetenekleri incele ve profillerine göz at."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <Junior />
                </>
              }
            />
            <Route
              path="/seniorlar"
              element={
                <>
                  <Helmet>
                    <title>Seniorlar - Mentör ve Değerlendirici Listesi</title>
                    <meta
                      name="description"
                      content="Platformdaki tüm Senior'ları keşfedin. Projelerde mentörlük yapan ve değerlendirme süreçlerine katılan deneyimli üyeleri bulun."
                    />
                    <meta
                      property="og:title"
                      content="Seniorlar – Değerlendirici ve Mentör Listesi"
                    />
                    <meta
                      property="og:description"
                      content="Platformdaki tüm Senior'ları burada görebilirsin. Projelerde mentörlük yapan veya değerlendirme süreçlerine katılan deneyimli üyeleri keşfet."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <Senior />
                </>
              }
            />
            <Route
              path="/sikca-sorulan-sorular"
              element={
                <>
                  <Helmet>
                    <title>SSS - Sıkça Sorulan Sorular</title>
                    <meta
                      name="description"
                      content="Juniors Center hakkında en çok merak edilen soruları ve açıklayıcı yanıtlarını burada bulabilirsiniz."
                    />
                    <meta
                      property="og:title"
                      content="SSS – Sıkça Sorulan Sorular"
                    />
                    <meta
                      property="og:description"
                      content="Juniors Center hakkında en çok merak edilen soruları ve açıklayıcı yanıtlarını burada bulabilirsin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <Sorular />
                </>
              }
            />
            <Route
              path="/kayit_ol"
              element={
                <>
                  <Helmet>
                    <title>Kayıt Ol – Gerçek Deneyim Seni Bekliyor</title>
                    <meta
                      name="description"
                      content="Hemen kaydolun, aktif projelere başvurun, ekiplerde yerinizi alın. Gerçek bir deneyim için ilk adımı atın."
                    />
                    <meta property="og:title" content="Kayıt Ol | Juniors" />
                    <meta
                      property="og:description"
                      content="Hemen kaydol, aktif projelere başvur, ekiplerde yerini al. Gerçek bir deneyim için ilk adımı at."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <Kayit />
                </>
              }
            />
            <Route
              path="/onay_kodu"
              element={
                <>
                  <Helmet>
                    <title>Onay Kodu - Hesap Doğrulama</title>
                    <meta
                      name="description"
                      content="E-posta adresinize gönderilen onay kodunu girin ve Juniors platformuna katılın."
                    />
                    <meta property="og:title" content="Onay Kodu | Juniors" />
                    <meta
                      property="og:description"
                      content="E-posta adresinize gönderilen onay kodunu girin ve Juniors platformuna katılın."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <Kayit2 />
                </>
              }
            />
            <Route
              path="/giris_yap"
              element={
                <>
                  <Helmet>
                    <title>Giriş Yap - Hesabınıza Erişin</title>
                    <meta
                      name="description"
                      content="Hesabınıza giriş yaparak projelere katılın, profilinizi düzenleyin, ekiplere dahil olun. Hemen başlayın."
                    />
                    <meta
                      property="og:title"
                      content="Giriş Yap – Hesabına Erişim Sağla"
                    />
                    <meta
                      property="og:description"
                      content="Hesabına giriş yaparak projelere katıl, profilini düzenle, ekiplere dahil ol. Şimdi harekete geç."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <Giris />
                </>
              }
            />
            <Route
              path="/sifre_yenileme"
              element={
                <>
                  <Helmet>
                    <title>Şifre Yenileme - Hesap Güvenliği</title>
                    <meta
                      name="description"
                      content="Juniors hesabınızın şifresini yenileyin. E-posta adresinize gönderilen bağlantı ile şifrenizi sıfırlayın."
                    />
                    <meta
                      property="og:title"
                      content="Şifre Yenileme | Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Juniors hesabınızın şifresini yenileyin. E-posta adresinize gönderilen bağlantı ile şifrenizi sıfırlayın."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <SifremiUnuttum />
                </>
              }
            />
            <Route
              path="/yeni_sifre_belirle"
              element={
                <>
                  <Helmet>
                    <title>Yeni Şifre - Hesap Güvenliği</title>
                    <meta
                      name="description"
                      content="Juniors hesabınız için yeni şifrenizi belirleyin. Güvenli ve güçlü bir şifre oluşturun."
                    />
                    <meta
                      property="og:title"
                      content="Yeni Şifre Belirle | Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Juniors hesabınız için yeni şifrenizi belirleyin. Güvenli ve güçlü bir şifre oluşturun."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <YeniSifre />
                </>
              }
            />
            <Route
              path="/kariyer_bilgileri"
              element={
                <>
                  <Helmet>
                    <title>Kariyer Bilgileri - Profil Tamamlama</title>
                    <meta
                      name="description"
                      content="Juniors platformunda kariyer bilgilerinizi güncelleyin. Becerilerinizi, deneyimlerinizi ve eğitim bilgilerinizi ekleyin."
                    />
                    <meta
                      property="og:title"
                      content="Kariyer Bilgileri | Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Juniors platformunda kariyer bilgilerinizi güncelleyin. Becerilerinizi, deneyimlerinizi ve eğitim bilgilerinizi ekleyin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <Kayit3 />
                </>
              }
            />
            <Route
              path="/hesabim/:userName"
              element={
                <>
                  <Helmet>
                    <title>Profilim – Bilgilerini Güncelle</title>
                    <meta
                      name="description"
                      content="Kendi profilinizi yönetin, yeteneklerinizi tanımlayın, projelerde sizi keşfetmeleri için bilgilerinizi güncel tutun."
                    />
                    <meta
                      property="og:title"
                      content="Profilim – Bilgilerini Güncelle"
                    />
                    <meta
                      property="og:description"
                      content="Kendi profilini yönet, yeteneklerini tanımla, projelerde seni keşfetmeleri için bilgilerini güncel tut."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <Hesabim />
                </>
              }
            />
            <Route
              path="/junior/:userName"
              element={
                <>
                  <Helmet>
                    <title>Junior Profili - Detaylı Bilgiler</title>
                    <meta
                      name="description"
                      content="Junior yazılımcı profilini görüntüleyin. Beceriler, projeler ve deneyimler hakkında detaylı bilgi edinin."
                    />
                    <meta
                      property="og:title"
                      content="Junior Profili - Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Junior yazılımcı profilini görüntüleyin. Beceriler, projeler ve deneyimler hakkında bilgi edinin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <JuniorDetay />
                </>
              }
            />
            <Route
              path="/senior/:userName"
              element={
                <>
                  <Helmet>
                    <title>Senior Profili - Detaylı Bilgiler</title>
                    <meta
                      name="description"
                      content="Senior yazılımcı profilini görüntüleyin. Deneyim, mentorluk ve projeler hakkında detaylı bilgi edinin."
                    />
                    <meta
                      property="og:title"
                      content="Senior Profili - Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Senior yazılımcı profilini görüntüleyin. Deneyim, mentorluk ve projeler hakkında bilgi edinin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <SeniorDetay />
                </>
              }
            />
            <Route
              path="/acik_riza_metni"
              element={
                <>
                  <Helmet>
                    <title>Açık Rıza Metni - Juniors</title>
                    <meta
                      name="description"
                      content="Juniors platformu açık rıza metni. Kişisel verilerinizin işlenmesi ve korunması hakkında detaylı bilgi edinin."
                    />
                    <meta
                      property="og:title"
                      content="Açık Rıza Metni - Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Juniors platformu açık rıza metni. Kişisel verilerinizin işlenmesi ve korunması hakkında bilgi edinin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <AcikRiza />
                </>
              }
            />
            <Route
              path="/uyelik_kullanici_sozlesmesi"
              element={
                <>
                  <Helmet>
                    <title>Üyelik Sözleşmesi - Kullanım Koşulları</title>
                    <meta
                      name="description"
                      content="Juniors platformu üyelik kullanıcı sözleşmesi. Platform kullanım koşulları ve haklarınız hakkında detaylı bilgi edinin."
                    />
                    <meta
                      property="og:title"
                      content="Üyelik Kullanıcı Sözleşmesi - Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Juniors platformu üyelik kullanıcı sözleşmesi. Platform kullanım koşulları ve haklarınız hakkında bilgi edinin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <UyelikKullanici />
                </>
              }
            />
            <Route
              path="/kvkk"
              element={
                <>
                  <Helmet>
                    <title>KVKK - Aydınlatma Metni</title>
                    <meta
                      name="description"
                      content="Juniors platformu KVKK aydınlatma metni. Kişisel verilerinizin korunması ve işlenmesi hakkında detaylı bilgi edinin."
                    />
                    <meta
                      property="og:title"
                      content="KVKK Aydınlatma Metni - Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Juniors platformu KVKK aydınlatma metni. Kişisel verilerinizin korunması ve işlenmesi hakkında detaylı bilgi edinin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <KvkkY />
                </>
              }
            />
            <Route
              path="/gizlilik_cerez_politikasi"
              element={
                <>
                  <Helmet>
                    <title>Gizlilik ve Çerez Politikası - Juniors</title>
                    <meta
                      name="description"
                      content="Juniors platformu gizlilik ve çerez politikası. Veri güvenliği, çerez kullanımı ve gizlilik haklarınız hakkında bilgi edinin."
                    />
                    <meta
                      property="og:title"
                      content="Gizlilik ve Çerez Politikası - Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Juniors platformu gizlilik ve çerez politikası. Veri güvenliği, çerez kullanımı ve gizlilik haklarınız hakkında bilgi edinin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <GizlilikCerez />
                </>
              }
            />
            <Route
              path="/bildirimler"
              element={
                <>
                  <Helmet>
                    <title>Bildirimler - Platform Güncellemeleri</title>
                    <meta
                      name="description"
                      content="Juniors platformundaki bildirimlerinizi görüntüleyin. Proje davetleri, mentorluk talepleri ve diğer önemli bildirimleri takip edin."
                    />
                    <meta property="og:title" content="Bildirimler - Juniors" />
                    <meta
                      property="og:description"
                      content="Juniors platformundaki bildirimlerinizi görüntüleyin. Proje davetleri, mentorluk talepleri ve diğer önemli bildirimleri takip edin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <Bildirimler setRatingIsOpen={setRatingState} />
                </>
              }
            />
            <Route
              path="/server-error"
              element={
                <>
                  <Helmet>
                    <title>Sunucu Hatası - Teknik Sorun</title>
                    <meta
                      name="description"
                      content="Juniors platformunda bir sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin."
                    />
                    <meta
                      property="og:title"
                      content="Sunucu Hatası - Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Juniors platformunda bir sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <ServerErrorPage />
                </>
              }
            />
            <Route
              path="/not-found"
              element={
                <>
                  <Helmet>
                    <title>Sayfa Bulunamadı - 404</title>
                    <meta
                      name="description"
                      content="Aradığınız sayfa bulunamadı. Juniors platformunda gezinmeye devam edin veya ana sayfaya dönün."
                    />
                    <meta
                      property="og:title"
                      content="Sayfa Bulunamadı - Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Aradığınız sayfa bulunamadı. Juniors platformunda gezinmeye devam edin veya ana sayfaya dönün."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <NotFoundPage />
                </>
              }
            />
            <Route
              path="*"
              element={
                <>
                  <Helmet>
                    <title>Sayfa Bulunamadı - Juniors</title>
                    <meta
                      name="description"
                      content="Aradığınız sayfa bulunamadı. Juniors platformunda gezinmeye devam edin."
                    />
                    <meta
                      property="og:title"
                      content="Sayfa Bulunamadı - Juniors"
                    />
                    <meta
                      property="og:description"
                      content="Aradığınız sayfa bulunamadı. Juniors platformunda gezinmeye devam edin."
                    />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  <NotFoundPage />
                </>
              }
            />
          </Routes>

          {ratingState.isOpen && (
            <Anket
              setRatingIsOpen={setRatingState}
              voteId={ratingState.voteId}
            />
          )}
          <Footer />
          <CerezPopup />
        </ErrorBoundary>
        <AppEventListener />
      </BrowserRouter>
      <ToastContainer />
    </HelmetProvider>
  );
};
// Hata yönlendirmelerini dinleyen komponent
const AppEventListener = () => {
  const navigate = useNavigate(); // `useNavigate` burada kullanılmalı

  useEffect(() => {
    const handleApiError = ({ status, path }) => {
      navigate(path); // Yönlendirme işlemi
    };

    // EventEmitter'dan gelen hataları dinliyoruz
    eventEmitter.on("apiError", handleApiError);

    // Component unmount olduğunda dinleyiciyi temizle
    return () => {
      eventEmitter.off("apiError", handleApiError);
    };
  }, [navigate]); // navigate bağımlılığı

  return null; // UI render etmiyoruz, sadece event dinleyicisi olarak çalışıyor
};
export default App;
